<template>
  <div class="z-card">
    <h4>{{ $t('pbx.phone-list.form.title.edit.main') }}</h4>

    <div class="z-card__body">
      <z-form-group class="row">
        <div class="col-2 text-right">
          {{ $t('pbx.phone-list.form.field.name') }}
        </div>
        <z-form-input class="col-10" :rules="{ required: false }" vid="name">
          <i-input v-model="form.name" :clearable="true" />
        </z-form-input>
      </z-form-group>
    </div>
  </div>
</template>

<script>
  import isEqual from 'lodash-es/isEqual';

  export default {
    props: {
      value: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        form: null
      };
    },

    watch: {
      value: {
        handler: function (value) {
          const { name = '', is_active = false } = value || {};
          this.form = { name, is_active };
        },
        immediate: true
      },

      form: {
        handler: function (form) {
          if (!isEqual(form, this.value)) {
            this.$emit('input', form);
          }
        },
        deep: true,
        immediate: true
      }
    },

    methods: {
      validate: function () {
        return this.$refs.form.validate();
      }
    }
  };
</script>
